import React, { useState } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { startOfDay, endOfDay } from 'date-fns';

import { Title, Thumbnail } from 'root/admin/components';
import store from 'root/admin/store';
import { Form, Field, Button, Row, FileInput, RelationSelect, Popconfirm } from '@smartplatform/ui';
import { formatDateStr } from '../../utils';
import { canCreateVotingForSession, createVotingForSession } from '../voting';
import { Editor } from '../../components';
import { VideoItem } from 'client/pages/plenary-session/VideoItem';

@withRouter
@observer
export default class PlenarySessionEdit extends React.Component {
	@observable record = null;
	@observable error = null;
	@observable isLoading = true;
	@observable videos = [];
	@observable openVote = false;
	@observable existingSessionId = null;
	@observable existingSession = null;
	@observable protocols = [];

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.id = this.props.match.params.id;
		if (this.id) {
			try {
				this.record = await store.model.PlenarySession.findById(this.id);
				this.videos = this.record.videos.map(url => ({ url: url, valid: true })) || [];
				if (this.record) {
					const { canCreate, sessionId } = await canCreateVotingForSession(this.record);
					this.openVote = canCreate;
					this.existingSessionId = sessionId;

					/**
					 * Проверка импорта из epz и интеграции с конгресс-системой
					 */

					const sessions = await store.model.Session.find({
						where: { plenarySessionId: this.id },
						include: [
							{
								relation: 'questions',
								scope: {
									fields: ['id'],
								},
							},
						],
						order: 'id desc',
					});
					this.existingSession = sessions.length > 0 ? sessions[0] : null;

					if (this.existingSession && this.existingSession.protocolDate) {
						try {
							const date0 = startOfDay(new Date(this.existingSession.protocolDate));
							const date1 = endOfDay(new Date(this.existingSession.protocolDate));
							this.protocols = await store.model.ConfProtocol.find({
								where: {
									and: [{ start: { gte: date0 } }, { end: { lte: date1 } }],
								},
								fields: ['id'],
								order: 'start asc',
							});
							console.log('protocols', this.protocols);
						} catch (e) {
							console.error(e);
						}
					}
				}
			} catch (e) {
				this.error = e.message;
			}
		} else {
			this.record = new store.model.PlenarySession();
			this.record.publishAt = new Date();
		}

		this.isLoading = false;
	};

	onMeetingChange = meeting => {
		if (!meeting) return;
		if (!this.record.name) this.record.name = meeting.name;
		console.log('started', meeting.startedAt);
		this.record.date = new Date(meeting.startedAt * 1000).toISOString();
	};

	addVideo = () => {
		this.videos.push({ url: '', valid: false });
	};

	beforeSave = record => {
		record.videos = this.videos.filter(record => record.valid).map(record => record.url);
	};

	onVideoUrlChange = (value, index, valid) => {
		this.videos[index].url = value;
		this.videos[index].valid = valid;
	};

	deleteVideo = index => this.videos.splice(index, 1);

	gotoExistingSession = () => {
		store.route.push({ path: `/admin/voting/${this.existingSessionId}` });
	};

	startRegistration = async () => {
		console.log('startRegistration');
		await createVotingForSession(this.record);
	};

	importSession = () => {
		store.route.push({ path: `/admin/plenarysessions/${this.id}/import` });
	};

	render() {
		if (this.isLoading) return '...';

		return (
			<div>
				<Title record={this.record} name="Публикация" />
				<Form record={this.record} beforeSave={this.beforeSave} rootPath="/admin">
					<Field property="name" label="Название" />
					<Field relation="meeting" label="Заседание (epz.iltumen.ru)">
						<RelationSelect
							property="name"
							filter={{
								where: { statusId: { neq: 3 } },
								order: 'id desc',
							}}
							onChange={this.onMeetingChange}
						/>
					</Field>
					<Field property="date" label="Дата заседания" disabled />

					{this.existingSession && (
						<div className="form-field">
							<a target="_blank" href={`/active-session/${this.existingSession.id}`}>
								Просмотреть голосование
							</a>
							{/*<Button className="btn-primary" onClick={this.gotoExistingSession}>Просмотреть голосование</Button>*/}
						</div>
					)}

					{this.id && (
						<div className="form-field">
							{this.existingSession ? (
								<div className="epz-info">
									<Button className="btn-primary" onClick={this.importSession}>
										Просмотр вопросов и работа с протоколами
									</Button>
									<div className="info">
										<div className="hdr">epz</div>
										<span>
											Вопросов: <strong>{this.existingSession.questions().length}</strong>
										</span>
									</div>
									<div className="info">
										<div className="hdr">Конгресс-система</div>
										<span>
											Дата:{' '}
											<strong>
												{this.existingSession.protocolDate
													? formatDateStr(this.existingSession.protocolDate, 'dd.MM.yyyy')
													: 'не выбрана'}
											</strong>
											.
										</span>
										{this.existingSession.protocolDate && (
											<span>
												Протоколы: <strong>{this.protocols.length > 0 ? this.protocols.length : 'не найдены'}</strong>.
											</span>
										)}
									</div>
								</div>
							) : (
								<Button className="btn-primary" onClick={this.importSession}>
									Импорт заседания из epz
								</Button>
							)}
						</div>
					)}

					{/*
					{this.openVote && <div className="form-field">
						<Popconfirm content="Создать онлайн голосование?" onConfirm={this.startRegistration}>
							<Button className="btn-primary">Создать голосование</Button>
						</Popconfirm>
					</div>}
*/}

					<Field property="text" label="Текст">
						<Editor />
					</Field>

					<Field property="agendaFilename" label="Повестка">
						<FileInput property="agendaFilename" />
					</Field>
					<Field property="newsletter" label="Бюллетень">
						<FileInput property="newsletter" />
					</Field>
					<Field property="protocol" label="Протокол">
						<FileInput property="protocol" />
					</Field>
					<Field property="transcript" label="Стенограмма">
						<FileInput property="transcript" />
					</Field>
					<Field property="transcript2" label="Стенограмма 2й день">
						<FileInput property="transcript2" />
					</Field>

					<Field label="Фоторепортаж" relation="gallery" property="name" />
					<Thumbnail record={this.record} label="Миниатюра" />

					{this.videos.map((item, index) => (
						<VideoItem url={item.url} index={index} key={index} onVideoUrlChange={this.onVideoUrlChange} onDelete={this.deleteVideo} />
					))}
					<div className="form-field">
						<Button onClick={this.addVideo} className="btn-primary">
							Добавить видео
						</Button>
					</div>
					<Field property="publish" label="Опубликовать" />
				</Form>
			</div>
		);
	}
}
